"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GmtlShipment = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class GmtlShipment extends model_core_1.Shipment {
    constructor(data, olMap) {
        super(data, olMap || index_1.olm);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, GmtlShipment);
    }
    setDimensions() {
        super.setDimensions();
        if (this.packaging?.manual && !this.packaging.handlingUnit) {
            this.packaging.handlingUnit = 'OTH';
        }
        if (!this.packaging?.manual && this.items?.length) {
            this.packaging = new model_core_1.Packaging({
                name: 'Calculated By setPackageDimensions Method',
                quantity: 1,
                manual: false,
                weight: this.total_weight,
                handlingUnit: 'OTH',
                dimensions: [
                    { name: 'Height' },
                    { name: 'Width' },
                    { name: 'Length' }
                ]
            });
            let dims = { Length: 0, Width: 0, Height: 0 };
            // Let's start by standardizing the dimensions of all the pieces.
            let addendum = new model_core_1.DimensionArray();
            for (let item of this.items) {
                // console.log('item.properties.shape', item.properties.shape);
                for (let x = 1; x <= item.quantity; x++) {
                    // Handle stackability.  Angles, for example may be 1" x 1" but you can stack them.
                    // So, replace the larger of the two dimensions with the Thickness.
                    // 'Angle' | 'Bar' | 'Beam' | 'Channel' | 'Pipe' | 'Plate' | 'Sheet' | 'Tube' | 'Grating' | 'U-Trim';
                    switch (item.properties?.shape) {
                        case 'Angle':
                            dims.Height += item.dimensions.get('Thickness').size; // Cut by an estimated amount to account for stackability.
                            addendum[0] = new model_core_1.Dimension({ name: 'Height' });
                            addendum[0].setSize(item.dimensions.get('Leg A').size);
                            dims.Width += item.dimensions.get('Thickness').size;
                            addendum[1] = new model_core_1.Dimension({ name: 'Width' });
                            addendum[1].setSize(item.dimensions.get('Leg B').size);
                            dims.Length = dims.Length || this.getLargestDimension('Length');
                            break;
                        default:
                            ['Height', 'Width'].forEach(p => {
                                if (item.dimensions.get(p)?.size) {
                                    dims[p] += item.dimensions.get(p)?.size || 0;
                                }
                                else if ((p === 'Height' || p === 'Width')
                                    &&
                                        (item.dimensions.get('Diameter')?.size || item.dimensions.get('Outside Diameter')?.size || item.dimensions.get('Outer Diameter')?.size)) {
                                    dims[p] += item.dimensions.get('Diameter')?.size || item.dimensions.get('Outside Diameter')?.size || item.dimensions.get('Outer Diameter')?.size || 0;
                                }
                                else if (p === 'Height' && !item.dimensions.get('Height')?.size) {
                                    if (item.dimensions.get('Thickness')?.size) {
                                        dims[p] += item.dimensions.get('Thickness')?.size || 0;
                                    }
                                    else if (item.dimensions.get('Flange')?.size) {
                                        dims[p] += item.dimensions.get('Flange')?.size || 0;
                                    }
                                    else if (item.dimensions.get('Opening')?.size) {
                                        dims[p] += item.dimensions.get('Opening')?.size || 0;
                                    }
                                    else if (item.dimensions.get('Bar Height')?.size) {
                                        dims[p] += item.dimensions.get('Bar Height')?.size || 0;
                                    }
                                }
                                else if (p === 'Width' && !item.dimensions.get('Width')?.size) {
                                    if (item.dimensions.get('Thickness')?.size) {
                                        dims[p] += item.dimensions.get('Thickness')?.size || 0;
                                    }
                                    else if (item.dimensions.get('Flange')?.size) {
                                        dims[p] += item.dimensions.get('Flange')?.size || 0;
                                    }
                                }
                                else {
                                    console.warn(`Item ${item.sku} is missing dimension: ${p}`);
                                }
                            });
                            dims.Length = dims.Length || this.getLargestDimension('Length');
                            // if (!item.properties?.shape) {
                            //     console.warn(item.sku);
                            // }
                            break;
                    }
                }
            }
            // Addendum (for stackable angles)
            if (addendum.length) {
                for (let dim of addendum) {
                    dims[dim.name] += dim.size;
                }
            }
            this.packaging.dimensions = new model_core_1.DimensionArray(Object.keys(dims).map((dim) => {
                let dObj = new model_core_1.Dimension({ name: dim });
                dObj.setSize(dims[dim]);
                return dObj;
            }));
            this.total_width = this.packaging.dimensions.get('Width').size;
            this.total_height = this.packaging.dimensions.get('Height').size;
            this.total_length = this.packaging.dimensions.get('Length').size;
        }
    }
    getLargestDimension(dim) {
        let result;
        if (this.packaging?.dimensions?.get && this.packaging?.dimensions?.get(dim)?.size) {
            result = this.packaging.dimensions.get(dim).size;
        }
        else {
            this.items?.forEach(i => {
                if (i.dimensions?.get && i.dimensions?.get(dim)?.size && (!result || i.dimensions?.get(dim)?.size > result)) {
                    result = i.dimensions.get(dim).size;
                }
            });
        }
        return result;
    }
}
exports.GmtlShipment = GmtlShipment;
index_1.olm.shipments = (ref, map) => {
    return new GmtlShipment(ref, map);
};
